export default __webpack_public_path__ + "img/catIcon13093.43c6d7b2.svg";